import type { SxProps, Theme } from "@mui/material";

/** Shared outlined control styling for HyperTable toolbar buttons. */
export const toolbarButtonSx: SxProps<Theme> = {
  gap: "0.35rem",
  alignItems: "center",
  borderRadius: "1rem",
  minHeight: "2.25rem",
  px: 1.25,
  py: 0.5,
  fontSize: "0.875rem",
  fontWeight: 500,
  whiteSpace: "nowrap",
  textTransform: "none",
  borderColor: (theme) => theme.palette.divider,
  color: "secondary.main",
  "& .MuiButton-startIcon": {
    margin: 0,
    marginInlineEnd: "0.15rem",
  },
  "& .MuiButton-endIcon": {
    margin: 0,
    marginInlineStart: "0.15rem",
  },
  "& .MuiSvgIcon-root": {
    fontSize: "1.15rem",
  },
};

export const toolbarCompactBadgeStyle = {
  fontSize: "x-small",
  width: "10px",
  minWidth: "15px",
  height: "15px",
  top: "28%",
  right: "18%",
} as const;

export const toolbarWideBadgeStyle = {
  right: "8%",
} as const;

export const toolbarMenuPaperSx: SxProps<Theme> = {
  minWidth: "11rem",
  mt: 0.5,
  borderRadius: "0.75rem",
  boxShadow: "0 4px 20px rgba(5, 32, 76, 0.12)",
};

export const toolbarOverflowExtrasSx: SxProps<Theme> = {
  px: 1.5,
  py: 0.75,
  width: "100%",
  "& .MuiFormControlLabel-root": {
    m: 0,
    width: "100%",
    justifyContent: "space-between",
    gap: 1,
  },
  "& .MuiFormControlLabel-label": {
    fontSize: "0.875rem",
    fontWeight: 500,
    color: "secondary.main",
  },
};
